import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from 'antd';
import { Megaphone, Eye } from 'lucide-react';
import dayjs from 'dayjs';
import { StatusTag, IconAction, EmptyState, CollapsibleCard } from '../../../common';

const CAMPAIGN_TYPE_MAP = {
    pop_blando: { label: 'POP Blando', tone: 'warning' },
    pop_duro: { label: 'POP Duro', tone: 'brand' }
};

function getStatusTag(campaign) {
    if (!campaign.active) return <StatusTag tone="neutral">Inactivo</StatusTag>;
    const isExpired = campaign.expirationDate && dayjs(campaign.expirationDate).isBefore(dayjs());
    return isExpired ? (
        <StatusTag tone="danger" dot>
            Expirado
        </StatusTag>
    ) : (
        <StatusTag tone="success" dot>
            Activo
        </StatusTag>
    );
}

const DateCell = ({ date }) => <span className="text-sm text-surface-600 tabular-nums">{date ? dayjs(date).format('DD/MM/YYYY') : '—'}</span>;

export default function ClientCampaignsSection({ campaigns }) {
    const navigate = useNavigate();
    const safeCampaigns = Array.isArray(campaigns) ? campaigns : [];

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-sm font-medium text-surface-900">{text}</span>
        },
        {
            title: 'Tipo',
            dataIndex: 'campaignType',
            key: 'campaignType',
            render: (type) => {
                const t = CAMPAIGN_TYPE_MAP[type] || { label: type, tone: 'neutral' };
                return <StatusTag tone={t.tone}>{t.label}</StatusTag>;
            }
        },
        {
            title: 'Inicio',
            dataIndex: 'startDate',
            key: 'startDate',
            render: (date) => <DateCell date={date} />
        },
        {
            title: 'Vencimiento',
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            render: (date) => <DateCell date={date} />
        },
        {
            title: 'Estado',
            key: 'status',
            render: (_, record) => getStatusTag(record)
        },
        {
            title: '',
            key: 'action',
            width: 64,
            align: 'right',
            render: (_, record) => (
                <IconAction icon={<Eye />} label="Ver campaña" onClick={() => navigate(`/dashboard/trade/campaigns/campaign?id=${record._id}`)} />
            )
        }
    ];

    return (
        <CollapsibleCard flush
            icon={<Megaphone />}
            iconTone="warning"
            title="Campañas"
            count={`${safeCampaigns.length} ${safeCampaigns.length === 1 ? 'campaña' : 'campañas'}`}
            countTone="warning">
            {safeCampaigns.length > 0 ? (
                <Table dataSource={safeCampaigns} columns={columns} rowKey="_id" pagination={false} size="middle" scroll={{ x: 640 }} />
            ) : (
                <EmptyState icon={<Megaphone />} title="Sin campañas" description="No hay campañas activas para este cliente" className="!py-8" />
            )}
        </CollapsibleCard>
    );
}
